<!-- Figma 28753:46113 (designer 2026-10-21): the model's still and name, whose it is, what could be
     better, the box, Back and Send. -->
<div class="rate">
  <ng-container *ngIf="!sent; else thanks">
    <div class="rate__model">
      <img *ngIf="data.job.preview?.landscapeCard as still" class="rate__still" [src]="still" alt="" width="84" height="84">
      <div class="rate__who">
        <h2 id="render-feedback-title" class="rate__name" [title]="data.job.name">{{ data.job.name }}</h2>
        <p *ngIf="data.userName" class="rate__user">{{ data.userName }}</p>
      </div>
    </div>

    <fieldset class="rate__group">
      <legend class="rate__question">What could be better?</legend>
      <div class="rate__chips">
        <button *ngFor="let chip of improve" class="rate__chip" type="button" [attr.aria-pressed]="isOn(chip.id)" [disabled]="sending" (click)="toggle(chip.id)">{{ chip.label }}</button>
      </div>
    </fieldset>

    <div class="rate__foot">
      <textarea
        class="rate__text"
        placeholder="Tell us more or report a bug..."
        aria-label="Tell us more or report a bug"
        maxlength="2000"
        [(ngModel)]="text"
        [disabled]="sending"></textarea>
      <p *ngIf="error" class="rate__error" role="alert">{{ error }}</p>
      <div class="rate__actions">
        <button class="rate__back" type="button" [disabled]="sending" (click)="onBack()">
          <img src="assets/images/render/account/back-chevron.svg" width="11.6493" height="18.5" alt="" />
          <span>Back</span>
        </button>
        <button class="rate__send" type="button" [disabled]="!canSend" (click)="onSend()">{{ sending ? 'Sending…' : 'Send' }}</button>
      </div>
    </div>
  </ng-container>

  <ng-template #thanks>
    <div class="rate__thanks" role="status">
      <h2 id="render-feedback-title" class="rate__name">Thank you</h2>
      <p>We read every one. It goes straight to the people who build the renders.</p>
      <button #doneButton class="rf-button rate__done" type="button" (click)="onDone()">Close</button>
    </div>
  </ng-template>
</div>
